<template>
  <div>
    <el-row class="row" :gutter="10">
      <el-col :span="24" style="text-align:right;">
        <cus-btn  type="download" @click="exportPDF()" />
      </el-col>
    </el-row>
    <div>
      <el-row v-if="companyType===1" class="row" :gutter="10">
        <el-col style="margin-top:10px;" :span="12">
          <card>
            <template #header>
              <card-header>{{ $t("homes.percentageOfCompanyTechnology") }}</card-header>
            </template>
            <div class="chart" style="height:200px;">
              <chart id="pdfChart" ref="companyChart" :options="optionsTechArea" />
            </div>
          </card>
        </el-col>

        <el-col
          style="margin-top:10px;"
          :span="12"
          v-if="isLoaded"
          v-for="(item,index) in techAreaList"
          :key="index"
        >
          <card>
            <template #header>
              <card-header>{{ $t("homes.percentageOfProjectPhases") }} - {{ item.value }}</card-header>
            </template>
            <div class="chart" style="height:200px;">
              <chart
                :id="'projectPhasesChart'+index"
                ref="projectPhaseChart"
                :options="item.options"
              />
            </div>
          </card>
        </el-col>
      </el-row>

      <el-row v-if="companyType===2" class="row" :gutter="10">
        <el-col :span="24">
          <card>
            <template #header>
              <card-header>{{ $t("homes.projectStatus") }}</card-header>
            </template>
            <stage-ratio id="project-status" :stage-item-data="stageItemData" />
          </card>
        </el-col>
      </el-row>
      <el-row class="row" :gutter="10">
        <el-col :span="24">
          <card>
            <template #header>
              <card-header>{{$t("homes.patentsTop10")}}</card-header>
            </template>
            <div class="chart" style="height:200px;">
              <chart id="top10Chart" ref="top10Chart" :options="optionsTop10" />
            </div>
          </card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import companyTech from "./components/companyTech";
import projectPhase from "./components/projectPhase";
import patentTop10 from "./components/patentTop10";

import echarts from "echarts/lib/echarts";
import html2canvas from "html2canvas";

import {
  percentageOfCompanyTechnologyArea,
  selectTechnicalArea,
  percentageOfProjectPhases,
  smallOrBigCompanyManager,
  patentsInTopTenCountries,
  projectPhaseStatus,
  getPDF
} from "@/api/homes";
// import jsPdf from 'jspdf'

export default {
  name: "",
  components: {
    "company-tech": companyTech,
    "project-phase": projectPhase,
    "patent-top-10": patentTop10
  },
  mixins: [],
  props: {
    // companyId:{
    //   type:Number,
    //   default:null
    // }
  },
  data() {
    return {
      companyType: 0, // 0-非公司管理员,1-大公司管理员,2-小公司管理员
      companyId: null,
      /** 所有技术领域数据请求是否完成 */
      isLoaded: false,
      stageItemData: [],
      /** 技术领域分布x轴 */
      xAxisTechArea: [],
      /** 技术领域分布数据 */
      ValuesTechArea: [],
      /** 技术领域列表 */
      techAreaList: [],
      /** top10 x轴 */
      xAxisTop10: [],
      /** top10 数据 */
      ValuesTop10: [],

      result: {
        techAreaPng: null,
        projectPhases: [],
        projectStatusPng: null,
        topTenPng: null
      }
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    },
    optionsTechArea() {
      return {
        color:['#EB7E65','#83D0EF','#A285D2','#FFAB67','#5B8FF9','#73DEB3','#7585A2','#F7C739','#92865D','#C6EBF8','#A5ADBE','#FBE5A2'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: 20,
          bottom: 20,
          icon: "circle",
          textStyle: {
            color: "#999999"
          },
          data: this.xAxisTechArea
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: true,
            center: ["78%", "50%"],
            data: this.ValuesTechArea,
            label: {
              formatter: "{c}"
            }
          }
        ]
      };
    },
    optionsTop10() {
      return {
        color:['#EB7E65','#83D0EF','#A285D2','#FFAB67','#5B8FF9','#73DEB3','#7585A2','#F7C739','#92865D','#C6EBF8','#A5ADBE','#FBE5A2'],
        color: ["#3DA4DD"],
        legend: {
          show: false
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: "rgba(61,164,211,0.1)"
            }
          }
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "3%",
          bottom: "1%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisTop10,
            axisLine: {
              lineStyle: {
                color: "#E5E5E5"
              }
            },
            axisLabel: {
              color: "#999999",
              interval: 0,
              formatter:function(params){
                if(params.length > 6){
                  return params.substring(0,5) + "..."
                }else{
                  return params
                }
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#E3E3E3"
              }
            },
            axisLabel: {
              color: "#999999"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#E9E9E9",
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            name: "Top10",
            type: "bar",
            barWidth: "60",
            data: this.ValuesTop10,
            itemStyle: {}
          }
        ]
      };
    }
  },
  watch: {
    lang() {
      this.init();
    }
  },
  created() {
    window.html2canvas = html2canvas;

    this.isLoaded = false;
    //this.init();
  },
  mounted() {},
  destroyed() {},
  methods: {
    /** 技术领域占比 */
    LoadTechAreaChart() {
      percentageOfCompanyTechnologyArea(this.companyId).then(resp => {
        const data = resp.data;
        this.xAxisTechArea = data.names;
        this.ValuesTechArea = data.values;
        this.$refs.companyChart.setOption(this.optionsTechArea);
      });
    },

    /** 技术领域 */
    LoadTechAreaAndProjectPhase() {
      selectTechnicalArea(this.companyId).then(resp => {
        this.techAreaList = resp.data;

        let reqCount = 0;
        if (this.techAreaList.length > 0) {
          for (let i = 0; i < this.techAreaList.length; i++) {
            percentageOfProjectPhases(
              this.techAreaList[i].key,
              this.companyId
            ).then(re => {
              const data = re.data;

              this.techAreaList[i].options = {
                color:['#EB7E65','#83D0EF','#A285D2','#FFAB67','#5B8FF9','#73DEB3','#7585A2','#F7C739','#92865D','#C6EBF8','#A5ADBE','#FBE5A2'],
                tooltip: {
                  trigger: "item",
                  formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                  orient: "vertical",
                  left: 20,
                  top: 20,
                  bottom: 20,
                  icon: "circle",
                  textStyle: {
                    color: "#999999"
                  },
                  data: data.names
                },
                series: [
                  {
                    name: "",
                    type: "pie",
                    radius: ["50%", "70%"],
                    avoidLabelOverlap: true,
                    center: ["78%", "50%"],
                    data: data.values,
                    label: {
                      formatter: "{c}"
                    }
                  }
                ]
              };

              ++reqCount;

              if (reqCount === this.techAreaList.length) {
                this.isLoaded = true;
                this.s++;
              }
            });
          }
        }
      });
    },

    /** top10 */
    LoadTop10() {
      patentsInTopTenCountries(this.companyId).then(resp => {
        const data = resp.data;

        this.xAxisTop10 = data.names;
        this.ValuesTop10 = data.values;

        this.$refs.top10Chart.setOption(this.optionsTop10);
      });
    },

    /** 项目阶段 */
    loadProjectPhases() {
      projectPhaseStatus(this.companyId).then(resp => {
        const data = resp.data;
        this.stageItemData = [];
        if (!data) {
          return;
        }

        for (let i = 0; i < data.data.length; i++) {
          let project = {};
          project.id = data.data[i].projectId;
          project.name = data.data[i].projectName;
          project.totalCount = data.data[i].phaseCount;
          project.children = [];

          let noPatentIndex = -1; //没有专利的阶段序号
          let noPatentCount = 0; //没有专利的阶段数量
          for (let p = 0; p < data.data[i].phaseList.length; p++) {
            let child = {
              id:data.data[i].phaseList[p].phaseId,
              name: data.data[i].phaseList[p].phaseName,
              count: data.data[i].phaseList[p].patentCount,
              iconNameArray: data.data[i].phaseList[p].patentAppNo
                ? data.data[i].phaseList[p].patentAppNo
                : [],
              isCurStep: data.data[i].phaseList[p].isCurrent == "0"
            };

            if (child.count > 0 || child.isCurStep) {
              //如果该阶段有专利或者是当前执行阶段，则重新清空序号
              noPatentIndex = -1;
              noPatentCount = 0;
            } else {
              if (noPatentIndex == -1) {
                //如果该阶段没有专利，并且没有记录序号时，记录当前序号
                noPatentIndex = p;
              }
              noPatentCount++;
            }
            if (p == data.data[i].phaseList.length - 1) {
              //最后一个阶段，如果有专利或者是当前执行阶段，则正常显示，否则作为最后未完成阶段
              child.type =
                child.count > 0 || child.isCurStep
                  ? undefined
                  : "LastUnFinshed";
              if (child.type) {
                noPatentCount--; //减去最后一个阶段
              }
            }
            project.children.push(child);
          }

          if(project.children.length >= 2 && project.children.length - noPatentCount < 2){
            //如果减去到最后一个阶段之前的无专利项后，小于两个阶段，则减少减去的数量
            let noPatentCountNew = project.children.length - 2//数量减少n个
            noPatentIndex += noPatentCount - noPatentCountNew//序号后移n位
            noPatentCount = noPatentCountNew
          }
          if (noPatentIndex > -1 && noPatentCount > 0) {
            //删除在最后一个阶段之前的没有专利的阶段
            project.children.splice(noPatentIndex, noPatentCount);
          }

          this.stageItemData.push(project);
        }
      });
    },

    init(compId) {
      this.companyId = compId;
      this.isLoaded = false;
      smallOrBigCompanyManager(this.companyId).then(resp => {
        this.companyType = resp.data.userType;

        if (this.companyType === 1) {
          // 大公司
          this.LoadTechAreaChart();

          this.LoadTechAreaAndProjectPhase();
        } else if (this.companyType === 2) {
          // 小公司
          this.loadProjectPhases();
        }
      });

      this.LoadTop10();
    },

    exportPDF() {
      let me = this;

      this.result.companyId = this.companyId

      if (this.companyType === 1) {
        this.result.techAreaPng = this.chartPng("pdfChart");

        this.result.projectPhases = [];
        for (let i = 0; i < this.techAreaList.length; i++) {
          this.result.projectPhases.push({
            techAreaName: this.techAreaList[i].value,
            projectPhasePng: this.chartPng("projectPhasesChart" + i.toString())
          });
        }

        this.result.topTenPng = this.chartPng("top10Chart");

        this.submit(this.result)
        // 大公司
      } else if (this.companyType === 2) {
        // 小公司
        html2canvas(document.getElementById("project-status")).then(function(canvas) {
          me.result.projectStatusPng = canvas.toDataURL("image/png");

          me.result.topTenPng = me.chartPng("top10Chart");

          me.submit(me.result);
        });
      }
    },
    /** 提交数据 */
    submit(rst){
      getPDF(rst).then(resp=>{
        const data = resp.data;
        if(data){
          window.open(data);
        }
      })
    },
    chartPng(chartDomId) {
      const chart = echarts.init(document.getElementById(chartDomId));
      return chart.getDataURL({
        type: "png",
        pixelRatio: 1,
        backgroundColor: "#fff"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  margin-bottom: 10px;
}
</style>
